function Story() {
  const journey = [
    {
      icon: 'fa-map-marker-alt',
      title: 'Dande Village, Ilam',
      text: 'Growing up in Dande village along the Mechi Highway, attending Shree Sarada Higher Secondary School. Crumbling walls. Wooden benches. No electricity. No science equipment. But students with dreams as vast as the Himalayan sky.',
    },
    {
      icon: 'fa-book-open',
      title: 'The Reality I Lived',
      text: 'Studying in classrooms with deteriorating walls and broken windows. Sharing torn textbooks among five students. Walking hours through mountain paths just to reach school. Yet every student showed up, hungry to learn.',
    },
    {
      icon: 'fa-laptop-code',
      title: 'Dallas, Texas',
      text: "Building a career as a software engineer in Dallas while carrying the weight of those classrooms\u2014the brilliant minds I left behind, limited only by walls without windows, benches without books, and schools without science labs.",
    },
    {
      icon: 'fa-hands-helping',
      title: 'Breaking the Cycle',
      text: "Bridges to Learning Foundation exists because potential knows no geography. The same determination that brought students to crumbling classrooms in the Himalayas lives in underserved communities across Dallas. Education is the bridge.",
    },
  ];

  const realityImages = [
    {
      src: '/assets/IMG_1840.JPG',
      title: 'This Is Where I Learned',
      caption: 'Deteriorating walls. Wooden benches. No electricity. Students at Shree Sarada Higher Secondary School, 2026.',
    },
    {
      src: '/assets/IMG_1841.JPG',
      title: 'Miles from Anywhere',
      caption: 'School nestled in remote Himalayas, hours from the nearest city. Ilam District, Eastern Nepal.',
    },
    {
      src: '/assets/IMG_1842.JPG',
      title: 'Making the Most of Nothing',
      caption: 'Playing volleyball on dirt grounds during breaks. No equipment. Just determination.',
    },
    {
      src: '/assets/IMG_1843.JPG',
      title: 'Packed Classrooms, Endless Potential',
      caption: 'Forty students in a room for twenty. One teacher. Textbooks from the 1990s. But look at their focus.',
    },
  ];

  return (
    <section className="story" id="story">
      <div className="container">
        <div className="story-header centered">
          <h2 className="section-title">These Walls Tell Our Story</h2>
          <p className="story-intro-main">
            This is where I learned. In classrooms with crumbling walls and wooden benches.
            Sharing textbooks. No science lab. No computers. Just pure determination and
            dreams that refused to fit within these walls. Today, as a software engineer in Dallas,
            I carry these classrooms with me\u2014not as a memory of limitation, but as a reminder
            of what's possible when we refuse to accept that zip codes should determine futures.
          </p>
        </div>

        <div className="story-reality-grid">
          {realityImages.map((img, i) => (
            <div className="story-reality-card" key={i}>
              <div className="story-reality-image">
                <img src={img.src} alt={img.title} loading="lazy" />
              </div>
              <div className="story-reality-text">
                <h4>{img.title}</h4>
                <p>{img.caption}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="story-content">
          <div className="story-text">
            <h3 className="story-subtitle">From Shree Sarada to Software Engineer</h3>
            <div className="story-journey">
              {journey.map((j, i) => (
                <div className="journey-point" key={i}>
                  <i className={`fas ${j.icon}`}></i>
                  <div>
                    <h4>{j.title}</h4>
                    <p>{j.text}</p>
                  </div>
                </div>
              ))}
            </div>
            <blockquote className="founder-quote">
              "Every time I write code in a climate-controlled office, I remember studying
              in rooms with broken windows and rain leaking through the roof. The gap between
              what students have and what they deserve exists in both Dallas and Dande.
              This foundation exists to close it."
              <cite>&mdash; Yogen Rai, Founder</cite>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Story;
